import axiosClient from "../apiClient";

export const getProfileListing = async (pageNumber = 1) => {
  return axiosClient.get(`admin/userListing?page=${pageNumber}&limit=7`);
};

export const getUserDetail = async (userId) => {
  return axiosClient.get(`admin/user/${userId}`);
};

export const updateUserStatus = async (userId) => {
  return axiosClient.get(`admin/userStatusChange/${userId}`);
};

/** A parent's videos. Metadata only — no playable links (see getVideoLink). */
export const getUserVideos = async (userId) => {
  return axiosClient.get(`admin/user/${userId}/videos`);
};

/**
 * Mints a playable link for one video, valid for 24 hours.
 *
 * Called on click rather than up front: the link works without login for as
 * long as it lives, so there is no reason to create one until someone actually
 * wants it. Minting on demand also means it is never expired when handed over.
 */
export const getVideoLink = async (videoId) => {
  return axiosClient.get(`admin/video/${videoId}/link`);
};

export const findUsers = async (pageNumber, query) => {
  return axiosClient.get(
    `admin/searchUser?searchKey=${query}&page=${pageNumber}&limit=7`
  );
};

export const deleteUser = async (userId) => {
  return axiosClient.delete(`admin/user/${userId}`);
};
